import { css } from 'styled-components';
import token from 'styled-token';
import { StyledText } from '../../components/Text/Text.styles';

/** @class PaginationItemMixin */
/** @method */
export var PaginationItemMixin = function PaginationItemMixin(props) {
  return token({
    marginX: 'PaginationItem.marginX',
    marginY: 'PaginationItem.marginY'
  }, function (_ref) {
    var marginX = _ref.marginX,
      marginY = _ref.marginY;
    return css(["display:block;margin:", "px ", "px;"], marginY, marginX);
  })(props);
};

// The readout is the "Page x of x" label that appears on smaller screens
export var PaginationReadoutItemMixin = function PaginationReadoutItemMixin(props) {
  return token('PaginationItem.textAlign', function (textAlign) {
    if (textAlign === void 0) {
      textAlign = 'center';
    }
    return css(["& > ", "{text-align:", ";display:inline-block;}"], StyledText, textAlign);
  })(props);
};